//import {mmodal} from './modal';
import {bindModalForm, bindForm} from "./bindForm";
import {PhoneMask}               from "./PhoneMask";
import {initDayTabs}             from "./day-tabs";
import {bindTabs}                from './tabs';

const toggleVisibility = (element, action = 'auto', params = {}, callback) => {
    if (!element) return false;

    const options = Object.assign(
        {
            display: 'block',
            changeHeight: true,
            changeOpacity: true,
            animation: 'ease-in-out',
            timeout: 200,
            styles: '',
        },
        params
    );

    const transition = `all ${options.timeout}ms ${options.animation}`;
    const isVisibleElement = checkVisible(element);

    if (action === 'show') {
        options._targetVisible = true;
    } else if (action === 'hide') {
        options._targetVisible = false;
    } else {
        options._targetVisible = !isVisibleElement;
    }

    if (options._targetVisible === isVisibleElement) return false;

    options.styles && element.setAttribute('style', options.styles); // get attr style

    if (options._targetVisible) {
        element.style.visibility = 'hidden';
        element.style.overflow = 'hidden';
        element.style.display = options.display;

        if (options.changeOpacity) {
            element.style.opacity = '0';
        }

        if (options.changeHeight) {
            const styles = getStyles(element);

            options._h = styles.h;
            options._pt = styles.pt;
            options._pb = styles.pb;
            options._mt = styles.mt;
            options._mb = styles.mb;
            options._btw = styles.btw;
            options._bbw = styles.bbw;

            element.style.height = '0';
            element.style.marginTop = '0';
            element.style.paddingTop = '0';
            element.style.marginBottom = '0';
            element.style.paddingBottom = '0';
            element.style.borderTopWidth = '0';
            element.style.borderBottomWidth = '0';
        }

        setTimeout(function () {
            element.style.transition = transition;
            element.style.visibility = 'visible';
        }, 0);
    } else {
        if (options.changeOpacity) {
            element.style.opacity = '1';
        }

        if (options.changeHeight) {
            const styles = getStyles(element);

            element.style.height = styles.h + 'px';
            element.style.marginTop = styles.mt + 'px';
            element.style.paddingTop = styles.pt + 'px';
            element.style.marginBottom = styles.mb + 'px';
            element.style.paddingBottom = styles.pb + 'px';
            element.style.borderTopWidth = styles.btw + 'px';
            element.style.borderBottomWidth = styles.bbw + 'px';
        }

        setTimeout(function () {
            element.style.overflow = 'hidden';
            element.style.transition = transition;
        }, 0);
    }

    setTimeout(function () {
        if (options.changeOpacity) {
            element.style.opacity = options._targetVisible ? '1' : '0';
        }

        if (options.changeHeight) {
            element.style.height = options._targetVisible ? options._h + 'px' : '0';
            element.style.marginTop = options._targetVisible ? options._mt + 'px' : '0';
            element.style.paddingTop = options._targetVisible ? options._pt + 'px' : '0';
            element.style.marginBottom = options._targetVisible ? options._mb + 'px' : '0';
            element.style.paddingBottom = options._targetVisible ? options._pb + 'px' : '0';
            element.style.borderTopWidth = options._targetVisible ? options._btw + 'px' : '0';
            element.style.borderBottomWidth = options._targetVisible ? options._bbw + 'px' : '0';
        }
    }, 0);

    setTimeout(function () {
        element.setAttribute('style', (options._targetVisible ? 'display:' + options.display + ';' : 'display:none;') + options.styles);

        typeof callback === 'function' && callback();
    }, options.timeout);

    function checkVisible(e) {
        const box = e.getBoundingClientRect();
        const height = box.height || box.bottom - box.top;
        const width = box.width || box.right - box.left;

        return !!height || !!width;
    }

    function getStyle(e, style) {
        return parseInt(getComputedStyle(e)[style], 10);
    }

    function getStyles(e) {
        return {
            h: e.offsetHeight,
            mt: getStyle(e, 'marginTop'),
            pt: getStyle(e, 'paddingTop'),
            mb: getStyle(e, 'marginBottom'),
            pb: getStyle(e, 'paddingBottom'),
            btw: getStyle(e, 'borderTopWidth'),
            bbw: getStyle(e, 'borderBottomWidth'),
        };
    }

    return true;
};

window.addEventListener('load', () => {

    const frontTabs = (node) => {
        if (!node) {
            return false;
        }

        const checkbox = node.querySelector('.front-tabs__toggle input');

        const toggleTab = (targetIndex) => {
            node.querySelector(`.front-tabs__head-item_active`).classList.remove('front-tabs__head-item_active');
            node.querySelector(`.front-tabs__head-item[data-target="${targetIndex}"]`).classList.add('front-tabs__head-item_active');

            node.querySelector(`.front-tabs__content-item_active`).classList.remove('front-tabs__content-item_active');
            node.querySelector(`.front-tabs__content-item[data-target="${targetIndex}"]`).classList.add('front-tabs__content-item_active');

            checkbox.checked = targetIndex === '2';
        }

        for (const control of node.querySelectorAll('.front-tabs__head-item')) {
            control.addEventListener('click', (e) => {
                e.preventDefault();
                if (control.classList.contains('front-tabs__head-item_active')) {
                    return false;
                }

                toggleTab(control.getAttribute('data-target'));
            })
        }


        checkbox.addEventListener('change', () => {
            if (checkbox.checked) {
                toggleTab("2");
                return true;
            }
            toggleTab("1");
        })
    }
    frontTabs(document.querySelector('.front-tabs'));


    const bindMenu = (node) => {
        if (!node) {
            return false;
        }

        const menu = document.querySelector('.header__menu');

        if (!menu) {
            return false;
        }

        node.addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector('.header__menu').classList.toggle('header__menu_open');
        });

        const buttons = menu.querySelectorAll('.w-children button');

        for (const button of buttons) {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                if (!button.classList.contains('open')) {
                    menu.querySelector('.w-children .open')
                    && menu.querySelector('.w-children .open').classList.remove('open');
                    button.classList.add('open');
                } else {
                    button.classList.remove('open');
                }
            })
        }

    }
    bindMenu(document.querySelector('.header__burger'));


    const frontSlider = (node) => {
        if (!node) {
            return false;
        }

        return new Swiper(node, {
            direction: 'horizontal',
            autoHeight: true,
            loop: true,
            preloadImages: false,
            lazy: true,
            watchSlidesProgress: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }
    frontSlider(document.querySelector('.front-slider .swiper'));

    const addShowMoreToCardsList = (node, maxWidth = 1050) => {
        if (!node) {
            return false;
        }

        const check = () => {
            if (window.matchMedia('(max-width:' + maxWidth + 'px)').matches
                && !node.querySelector('.cards-list__btn')) {
                return true;
            }
            return false;
        }

        const addToggle = () => {
            const btn = document.createElement('button');
            btn.setAttribute('type', 'button');
            btn.classList.add('cards-list__btn');
            btn.innerText = 'Смотреть все';

            node.append(btn);

            node.classList.toggle('cards-list_short');

            btn.addEventListener('click', (e) => {
                e.preventDefault();
                node.classList.toggle('cards-list_short')
                btn.innerText = btn.innerText === 'Смотреть все' ? 'Свернуть' : 'Смотреть все';
            })
        }

        if (check()) {
            addToggle();
        }

        window.addEventListener('resize', () => {
            if (check()) {
                addToggle();
            }
        })

    }
    addShowMoreToCardsList(document.querySelector('.cards-list'));

    const calcMinHeight = (nodeList) => {
        let height = 0;

        for (const item of nodeList) {
            height = item.offsetHeight > height ? item.offsetHeight : height;
        }

        return height;
    }


    const bindFaq = (node) => {
        if (!node) {
            return false;
        }

        const items = node.querySelectorAll('.faq__item');
        const minHeight = window.matchMedia('(min-width: 1101px)').matches ? calcMinHeight(items) : 0;

        for (const item of items) {
            item.querySelector('.faq__item-head').style.minHeight = minHeight + 'px';
            item.querySelector('.faq__item-head').addEventListener('click', (e) => {
                e.preventDefault();
                if (item.classList.contains('faq__item_show')) {
                    item.classList.remove('faq__item_show');
                } else {
                    for (const item of items) {
                        item.classList.remove('faq__item_show');
                    }

                    item.classList.add('faq__item_show');
                }
                // item.classList.toggle('faq__item_show');
            })
        }
    }

    bindFaq(document.querySelector('.faq'));

    const bindGallery4 = (node) => {
        if (!node) {
            return false;
        }
        return new Swiper(node, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 32,
            preloadImages: false,
            lazy: true,
            watchSlidesProgress: true,
            pagination: {
                el: ".swiper-pagination",
                type: "fraction",
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                1350: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
                980: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                680: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
            }
        })
    }

    for (const gallery of document.querySelectorAll('.js-gallery-4-items')) {
        bindGallery4(gallery);
    }

    const bindGalleryFw = (node) => {
        if (!node) {
            return false;
        }

        return new Swiper(node, {
            slidesPerView: 'auto',
            //centeredSlides: true,
            //centeredSlidesBounds: true,
            watchSlidesProgress: true,
            //slidesPerGroupAuto: true,
            preloadImages: false,
            lazy: true,
            // loop: true,
            //initialSlide: 3,
            spaceBetween: 32,
            pagination: {
                el: ".swiper-pagination",
                type: "fraction",
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        })
    }

    for (const gallery of document.querySelectorAll('.js-gallery-auto-items')) {
        bindGalleryFw(gallery);
    }


    const copyElement = (selector, targetParent, mQuery) => {
        const element = document.querySelector(selector);
        const target = document.querySelector(targetParent);

        if (!element || !target) {
            return false;
        }

        const pasteClone = () => {
            if (window.matchMedia(mQuery).matches && !target.innerHTML.trim(' ')) {
                target.append(element.cloneNode(true))
            }
        };

        pasteClone();

        window.addEventListener('resize', pasteClone);

    }

    copyElement('.about-goods__list', '.about-goods__list-mobile', '(max-width: 1100px)');

    const expandBlock = (triggerSelector, targetSelector) => {
        const element = document.querySelector(triggerSelector);
        const target = document.querySelector(targetSelector);

        if (!element || !target) {
            return false;
        }

        element.addEventListener('click', (e) => {
            e.preventDefault();
            element.classList.toggle('m-open');
            target.classList.toggle('m-open');
        })
    }

    expandBlock('.btn_icon-expand', '.about-goods__list-mobile');


    // вызов модалок форм на странице программ
    Fancybox.bind('.js-program-btn', {
        groupAll: false,
        type: "inline",
        on: {
            done: () => {

                const programNameNode = document.querySelector('.m-course h1');
                const programSubsection = document.querySelector('.m-course__options-subsection input:checked ~ label b');
                const system = document.querySelector('input[name="system"]:checked');
                const level = document.querySelector('input[name="levels"]:checked');
                const city = document.querySelector('.m-course__options-item_places');
                const checkOut = document.getElementById('checkboxOut');

                const nameInputs = [...document.querySelectorAll('input[name="PROPERTY[COURSE_NAME]"]')];
                if (programNameNode) {
                    nameInputs.map((nameInput) => {
                        nameInput.value = `
                        ${programNameNode && programNameNode.getAttribute('data-section') ? programNameNode.getAttribute('data-section') : ''} - 
                        ${programNameNode ? programNameNode.innerText : ''} - 
                        ${programSubsection ? programSubsection.innerText : ''} -  
                        ${system ? system.value : ''} - 
                        ${level ? level.value : ''} - 
                        ${city && city.getAttribute('data-current') ? city.getAttribute('data-current') : ''}
                        ${checkOut && checkOut.checked ? 'Выездное обучение' : ''}
                        `;
                    })
                } else {
                    nameInputs.map((nameInput) => {
                        nameInput.value = '';
                    })
                }
                const promo = sessionStorage.getItem('sessionPromo');
                const discount = sessionStorage.getItem('sessionPromoDiscount');

                if (promo) {
                    [...document.querySelectorAll('input[name="PROPERTY[PROMO_CODE]"]')].map((promoInput) => {
                        promoInput.value = promo;
                    })
                }

                if (discount) {
                    [...document.querySelectorAll('input[name="PROPERTY[PROMO_DISCOUNT]"]')].map((discountInput) => {
                        discountInput.value = discount;
                    })
                }

                const oldPriceNode = document.querySelector('.m-course-info__price-value');
                const newPriceNode = document.querySelector('.m-course-info__p-price-new');

                if (newPriceNode) {
                    [...document.querySelectorAll('input[name="PROPERTY[SHOWN_PRICE]"]')].map((priceInput) => {
                        priceInput.value = newPriceNode.innerText.replace(/[^0-9]/g, "");
                    })
                } else if (oldPriceNode) {
                    [...document.querySelectorAll('input[name="PROPERTY[SHOWN_PRICE]"]')].map((priceInput) => {
                        priceInput.value = oldPriceNode.getAttribute('data-price') ? oldPriceNode.getAttribute('data-price') : oldPriceNode.innerText.replace(/[^0-9]/g, "");
                    })
                }
            },
        }
    })

    // привязка форм
    const forms = document.querySelectorAll('.js-form');
    for (const form of forms) {
        bindForm(form);
    }

    const bindProgramCalendar = (node) => {
        if (!node) {
            return false;
        }

        const getDates = (el) => {
            const string = el.getAttribute('data-dates');
            if (!string) {
                el.parentNode.parentNode.remove();
                return false;
            }

            const ranges = string.split(';').map(el => el.split(','));

            const getDatesBetweenDates = (start, end) => {
                let dates = [];
                const theDate = new Date(start);
                const endDate = new Date(end);
                while (theDate < endDate) {
                    dates = [...dates, new Date(theDate)];
                    theDate.setDate(theDate.getDate() + 1);
                }
                dates = [...dates, endDate];
                return dates;
            }

            return ranges.map(el => getDatesBetweenDates(...el)).flat();
        }

        const dates = getDates(node);

        if (dates) {
            return new Datepicker(node, {
                calendarWeeks: false,
                todayHighlight: true,
                maxView: 0,
                language: 'ru',
                datesDisabled: dates,
                nextArrow: '',
                prevArrow: '',
            });
        }
        return false;
    }

    const bindPrograms = (node) => {
        if (!node) {
            return false;
        }

        const root = node;
        const titles = root.querySelectorAll('.programs__list-item');
        const contents = root.querySelectorAll('.programs-item');

        const changeTab = (anchorStr, noScroll) => {
            for (const title of titles) {
                if (title.classList.contains('programs__list-item_active')
                    && title.getAttribute('href') === anchorStr) {
                    continue;
                }
                if (title.classList.contains('programs__list-item_active')) {
                    title.classList.remove('programs__list-item_active');
                }
                if (title.getAttribute('href') === anchorStr) {
                    title.classList.add('programs__list-item_active');
                }
            }

            for (const content of contents) {
                if (content.getAttribute('id') === anchorStr.substring(1)) {
                    content.classList.remove('programs-item_hidden');
                    !content.querySelector('.datepicker') && bindProgramCalendar(content.querySelector('.programs-item__calendar-element'));
                    setTimeout(() => {
                        if (window.matchMedia('(max-width: 990px)').matches && !noScroll) {
                            content.scrollIntoView();
                        }
                    }, 500);
                    continue;
                }
                content.classList.add('programs-item_hidden');
            }
        }

        const searchParams = (new URL(document.location)).searchParams;
        const target = searchParams.get('program');

        if (target) {
            changeTab(`#${target}`);
        } else {
            changeTab(titles[0].getAttribute('href'), true);
        }


        for (const title of titles) {
            title.addEventListener('click', (e) => {
                e.preventDefault();
                changeTab(title.getAttribute('href'));
            })
        }
    }

    for (const programs of document.querySelectorAll('.programs')) {
        bindPrograms(programs);
    }

    initDayTabs('.js-day-tabs');

    const setTitlesSameHeight = (root) => {
        if (!root) {
            return false;
        }

        const items = [...root.querySelectorAll('.js-title-height')];

        const maxHeight = items.reduce((acc, el) => {
            return el.offsetHeight > acc ? el.offsetHeight : acc;
        }, 0)

        items.map((el) => {
            el.style.minHeight = maxHeight + 'px';
        })
    }

    for (const titlesRoot of document.querySelectorAll('.js-title-height-parent')) {
        setTitlesSameHeight(titlesRoot);
        window.addEventListener('resize', () => {
            setTitlesSameHeight(titlesRoot);
        })
    }

    const initLearningStages = block => {
        const buttons = block && block.querySelectorAll('[data-button]');
        const items = block && block.querySelectorAll('[data-item]');
        const infoBlocks = block && block.querySelectorAll('[data-info]');

        if (!block || !buttons[0] || !items[0]) return false;

        buttons.forEach(currentButton => {
            currentButton.addEventListener('click', function () {
                if (currentButton.classList.contains('active')) return false;

                const id = currentButton.getAttribute('data-button');

                buttons.forEach(button => {
                    if (button.getAttribute('data-button') === id) {
                        button.classList.add('active');
                    } else {
                        button.classList.remove('active');
                    }
                });

                items.forEach(item => {
                    if (item.getAttribute('data-item') === id) {
                        item.classList.add('active');
                    } else {
                        item.classList.remove('active');
                    }
                });

                infoBlocks[0] && infoBlocks.forEach(infoBlock => {
                    if (infoBlock.getAttribute('data-info') === id) {
                        toggleVisibility(infoBlock, 'show', {}, function () {
                            infoBlock.classList.remove('hide');
                        });
                    } else {
                        toggleVisibility(infoBlock, 'hide', {}, function () {
                            infoBlock.classList.add('hide');
                        });
                    }
                });
            });
        });
    }
    const initSwitchLearningBlock = () => {
        const mainBlock = document.querySelector('.az-stages-block');
        if (!mainBlock) return false;
        const btns = mainBlock.querySelectorAll('[data-learning-btn]');
        const contentBlocks = mainBlock.querySelectorAll('[data-learning-block]');

        [...btns].map((currentBtn) => {
            currentBtn.addEventListener('click', () => {
                if (currentBtn.classList.contains('active')) return false;

                const id = currentBtn.getAttribute('data-learning-btn');

                [...btns].map((btn) => {
                    if (btn.getAttribute('data-learning-btn') === id) {
                        btn.classList.add('active');
                    } else {
                        btn.classList.remove('active');
                    }
                });
                [...contentBlocks].map((block) => {
                    if (block.getAttribute('data-learning-block') === id) {
                        block.classList.add('active');
                    } else {
                        block.classList.remove('active');
                    }
                })

            })

        })
    }
    const learningStagesBlocks = document.querySelectorAll('.js-learning-stages');

    const initSwiperSwitcher = () => {
        let swiperElem;

        const initSwiper = () => {
            swiperElem = new Swiper('.js-swiper-block', {
                slidesPerView: 'auto',
                pagination: false,
                navigation: false,
            })
        }

        const destroySwiper = () => {
            if (swiperElem) {
                swiperElem.destroy(true, true);
                swiperElem = undefined;
            }
        }

        const checkWidth = () => {
            if (window.innerWidth < 830) {
                if (!swiperElem) {
                    initSwiper();
                }
            } else {
                if (swiperElem) {
                    destroySwiper();
                }
            }
        }

        window.addEventListener('resize', checkWidth);
        checkWidth();

    }
    const switchFullTeachersBlock = () => {
        const btns = document.querySelectorAll('.js-teachers-switcher');
        if (!btns.length) return false;
        [...btns].map((btn) => {
            btn.addEventListener('click', () => {
                const parent = btn.closest('.teachers__block');
                const textBlock = parent.querySelector('.teachers__item-sign');
                if (textBlock.classList.contains('active')) {
                    textBlock.classList.remove('active');
                    btn.innerHTML = 'Подробнее';
                } else {
                    textBlock.classList.add('active');
                    btn.innerHTML = 'Скрыть информацию';
                }
            })
        })
    }

    [...learningStagesBlocks].map(block => initLearningStages(block));
    initSwitchLearningBlock();
    initSwiperSwitcher();
    switchFullTeachersBlock();

    const initCertificatesSwiper = () => {
        const swiper = new Swiper('.js-certificats-gallery', {
            slidesPerView: 1,
            lazy: true,
            spaceBetween: 16,
            pagination: {
                el: ".swiper-pagination",
                type: "fraction",
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            // breakpoints: {
            //   750: {
            //     slidesPerView: 2,
            //   }
            // }
        })
    }
    initCertificatesSwiper();

    const initFancyGalleries = () => {
        Fancybox.bind('[data-fancybox="certificate-gallery"]', {});
        Fancybox.bind('[data-fancybox="learning-stages-gallery"]', {});
    }
    initFancyGalleries();

    const bindContactsSwiper = (node) => {
        new Swiper(node, {
            spaceBetween: 16,
        });
    }

    for (const contactSwiperNode of document.querySelectorAll('.contacts-item__gallery .swiper')) {
        bindContactsSwiper(contactSwiperNode);
    }

    bindTabs('.js-tabs');

    const bindSectionsFilters = () => {
        const root = document.querySelector('.m-catalog-sections');
        if (!root) {
            return false;
        }

        const filters = [...document.querySelectorAll('.m-catalog-sections__filter-select select')];
        if (!filters.length) {
            return false;
        }

        const items = [...root.querySelectorAll('.m-catalog-sections__item')];

        const filterItems = (value = 'all') => {
            if (value === 'all') {
                items.map((item) => {
                    item.style.removeProperty('display');
                })
                return true;
            }
            items.map((item) => {
                if (!item.getAttribute(`data-${value}`)) {
                    item.style.display = 'none';
                } else {
                    item.style.removeProperty('display');
                }
            })

        }

        filters.map((select) => {
            const options = {
                searchable: false,
                placeholder: select.getAttribute('data-placeholder'),
                selectedtext: 'выбрано'
            };
            NiceSelect.bind(select, options);

            const type = select.getAttribute('data-type');
            const customList = document.createElement('div');
            const customClass = type === 'radio' ? 'm-catalog-sections__custom-list__radio' : 'm-catalog-sections__custom-list__checkbox';
            customList.classList.add('m-catalog-sections__custom-list', customClass);
            [...select.querySelectorAll('option')].map((option) => {
                const label = document.createElement('label');
                const input = document.createElement('input');
                const span = document.createElement('span');
                input.type = type;
                span.innerText = option.value === 'all' ? 'Все' : option.textContent;
                if (type === 'checkbox') {
                    input.name = 'checkbox-options';
                    span.classList.add('checkbox');
                }
                if (type === 'radio') {
                    input.name = 'radio-options';
                    input.setAttribute('data-value', option.value);
                    span.classList.add('radio');
                }

                label.append(input, span);
                customList.appendChild(label);
            });
            const selectsParent = select.closest('.m-catalog-sections__filter-select');
            selectsParent.appendChild(customList);


            select.addEventListener('change', (e) => {
                if (window.innerWidth > 1250) {
                    filterItems(select.value);
                }
            })
        })

        const mobileFilterBtn = root.querySelector('.js-filter-btn');
        const mobileShowResultBtn = root.querySelector('.js-btn-filter-result');
        const filtersBlock = root.querySelector('.js-filter-block');
        const mobileCloseBtn = root.querySelector('.js-filters-close-btn');

        mobileFilterBtn.addEventListener('click', () => {
            filtersBlock.classList.add('active');
            document.body.classList.add('m-catalog-sections__filters-body-style');

        });

        mobileShowResultBtn.addEventListener('click', () => {
            const inputs = filtersBlock.querySelectorAll('input');
            const checkedInputs = [...inputs].filter(input => input.checked);
            checkedInputs.map(el => filterItems(el.dataset.value));
            if (checkedInputs.length > 1) {
                mobileFilterBtn.classList.contains('active') ? '' : mobileFilterBtn.classList.add('active');
            } else if (checkedInputs.length === 1) {
                const checkedValue = checkedInputs[0].dataset.value;
                if (checkedValue === 'all') {
                    mobileFilterBtn.classList.contains('active') ? mobileFilterBtn.classList.remove('active') : '';
                } else {
                    mobileFilterBtn.classList.contains('active') ? '' : mobileFilterBtn.classList.add('active');
                }
            } else {
                mobileFilterBtn.classList.contains('active') ? mobileFilterBtn.classList.remove('active') : '';
            }

            filtersBlock.classList.remove('active');
            document.body.classList.remove('m-catalog-sections__filters-body-style');
        })

        mobileCloseBtn.addEventListener('click', () => {
            filtersBlock.classList.remove('active');
            document.body.classList.remove('m-catalog-sections__filters-body-style');
        })
    }

    bindSectionsFilters();

    const updatePricesWithPromo = (percentString, reset) => {

        const priceNodes = [...document.querySelectorAll('.programs-item__price')];

        if (!priceNodes.length) {
            return false;
        }

        if (reset) {
            priceNodes.map((priceNode) => {
                const newPriceNode = priceNode.querySelector('.programs-item__price-new');
                newPriceNode && newPriceNode.remove();
                const messageNode = priceNode.querySelector('.programs-item__price-message');
                messageNode && messageNode.remove();

                priceNode.classList.remove('programs-item__price_w-code');

                sessionStorage.removeItem('sessionPromo');
                sessionStorage.removeItem('sessionPromoDiscount');
            })
        }

        if (!percentString) {
            return false;
        }

        const percentNumber = Number(percentString);

        if (isNaN(percentNumber)) {
            return false;
        }

        priceNodes.map((priceNode) => {
            const text = priceNode.innerText.replace(/[^0-9]/g, "");
            const priceNumber = Number(text);

            const newPrice = priceNumber * .8;

            const newPriceNode = document.createElement('div');
            newPriceNode.classList.add('programs-item__price-new');
            newPriceNode.innerText = new Intl.NumberFormat('ru-RU', {
                style: 'currency', currency: 'RUB', maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            }).format(
                newPrice,
            );
            priceNode.append(newPriceNode);

            const messageNode = document.createElement('div');
            messageNode.classList.add('programs-item__price-message');
            messageNode.innerText = `-${percentString}% по промокоду`;
            priceNode.append(messageNode);

            priceNode.classList.add('programs-item__price_w-code');
        })
    }

    const bindPromoInputs = () => {

        const wrappers = [...document.querySelectorAll('.programs-item__pcode')];

        if (!wrappers.length) {
            return false;
        }

        wrappers.map((wrapper) => {
            const input = wrapper.querySelector('.programs-item__pcode-input');

            input.addEventListener('input', (e) => {
                if (input.value.trim(' ') !== '') {
                    wrapper.classList.add('programs-item__pcode_check');
                } else {
                    wrapper.classList.remove('programs-item__pcode_check');
                    wrapper.classList.remove('programs-item__pcode_del');
                    wrapper.classList.remove('programs-item__pcode_progress');
                }
            })

            const button = wrapper.querySelector('.programs-item__pcode-action');
            const errNode = wrapper.querySelector('.programs-item__pcode-error');

            const resetBtn = wrapper.querySelector('.programs-item__pcode-reset');

            resetBtn.addEventListener('click', e => {
                e.preventDefault();
                wrappers.map((w) => {
                    w.classList.remove('programs-item__pcode_check');
                    w.classList.remove('programs-item__pcode_progress');
                    w.classList.remove('programs-item__pcode_error');
                    w.classList.remove('programs-item__pcode_del');
                    const i = w.querySelector('.programs-item__pcode-input');
                    i.value = '';
                    i.removeAttribute('readonly', 'readonly');
                })

                updatePricesWithPromo(null, true);
            })

            wrapper.addEventListener('submit', (e) => {
                e.preventDefault();
                wrapper.classList.remove('programs-item__pcode_check');
                wrapper.classList.add('programs-item__pcode_progress');

                fetch(`/ajax/get_discount_by_promocode.php?code=${input.value.trim(' ')}`)
                    .then(res => res.json())
                    .then(data => {
                        if (data.status === 'error') {
                            errNode.innerText = 'Промокод не найден';
                            wrapper.classList.remove('programs-item__pcode_progress');
                            wrapper.classList.add('programs-item__pcode_check');
                            wrapper.classList.add('programs-item__pcode_error');
                            input.select();
                            setTimeout(() => {
                                wrapper.classList.remove('programs-item__pcode_error');
                            }, 8000)
                            return false;
                        }
                        if (data.status === 'ok' && data['discount_percent']) {
                            wrapper.classList.remove('programs-item__pcode_check');
                            wrapper.classList.remove('programs-item__pcode_progress');
                            wrapper.classList.remove('programs-item__pcode_error');
                            wrapper.classList.add('programs-item__pcode_del');
                            input.setAttribute('readonly', 'readonly');
                            updatePricesWithPromo(data['discount_percent']);
                            sessionStorage.setItem('sessionPromo', input.value.trim(' '));
                            sessionStorage.setItem('sessionPromoDiscount', data['discount_percent']);

                            wrappers.map((w) => {
                                const i = w.querySelector('.programs-item__pcode-input');
                                if (!i) return false;
                                i.value = input.value.trim(' ');
                                w.classList.remove('programs-item__pcode_check');
                                w.classList.remove('programs-item__pcode_progress');
                                w.classList.remove('programs-item__pcode_error');
                                w.classList.add('programs-item__pcode_del');
                                i.setAttribute('readonly', 'readonly');
                            })

                            return true;
                        }
                    }).catch((err) => {
                    console.log(err)
                    errNode.innerText = 'Ошибка связи с сервером';
                    wrapper.classList.add('programs-item__pcode_error');
                    wrapper.classList.remove('programs-item__pcode_progress');
                    wrapper.classList.add('programs-item__pcode_check');
                    setTimeout(() => {
                        wrapper.classList.remove('programs-item__pcode_error');
                    }, 8000)
                })
            })
        })
    }

    const checkPromoSessionStorage = () => {
        const promo = sessionStorage.getItem('sessionPromo');
        const percent = sessionStorage.getItem('sessionPromoDiscount');

        if (!promo || !percent) {
            return false;
        }

        const pcodeWrappers = [...document.querySelectorAll('.programs-item__pcode')];

        if (!pcodeWrappers.length) {
            return false;
        }

        pcodeWrappers.map((wrapper) => {
            const input = wrapper.querySelector('.programs-item__pcode-input');
            wrapper.classList.remove('programs-item__pcode_check');
            wrapper.classList.remove('programs-item__pcode_progress');
            wrapper.classList.remove('programs-item__pcode_error');
            wrapper.classList.add('programs-item__pcode_del');
            input.value = promo;
            input.setAttribute('readonly', 'readonly');
        })
        updatePricesWithPromo(percent);
    }

    const checkSearchString = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const promo = urlParams.get('promo');
        if (!promo) {
            return false;
        }

        fetch(`/ajax/get_discount_by_promocode.php?code=${promo}`)
            .then(res => res.json())
            .then(data => {
                if (data.status === 'error') {
                    return false;
                }
                if (data.status === 'ok' && data['discount_percent']) {
                    sessionStorage.setItem('sessionPromo', promo);
                    sessionStorage.setItem('sessionPromoDiscount', data['discount_percent']);
                    return true;
                }
            }).catch((err) => {
            console.log(err)

        })
    }

    document.querySelectorAll(".header__contacts-item_mail a, .footer__contacts-item_mail").forEach((el) => {
        el.oncopy = function (event) {
            ym(90068350, 'reachGoal', 'email-des');
        }
        el.addEventListener('touchend', function (event) {
            ym(90068350, 'reachGoal', 'email-des');
        });
    })

    checkSearchString();
    //bindPromoInputs();
    //checkPromoSessionStorage();

    const setCatalogSelects = async (node) => {
        if (!node) {
            return false;
        }
        const sectionId = node.getAttribute('data-section-id');
        const sectionLink = node.getAttribute('data-section-link');

        const currentParams = new URLSearchParams(window.location.search);
        const targetLink = new URL(sectionLink, window.location.origin);

        currentParams.forEach((value, key) => {
            targetLink.searchParams.set(key, value);
        })

        if (!sectionId) {
            return false;
        }

        const citiesSelect = node.querySelector('.js-cities-select');
        const programsSelect = node.querySelector('.js-programs-select');
        const link = node.querySelector('.js-m-selects-link');

        if (!citiesSelect || !programsSelect || !link) {
            node.remove();
            return false;
        }

        const options = {
            searchable: false,
            //placeholder: select.getAttribute('data-placeholder'),
            selectedtext: 'выбрано'
        };
        const niceCities = NiceSelect.bind(citiesSelect, options);
        const nicePrograms = NiceSelect.bind(programsSelect, options);

        await fetch('/ajax/get_cities_arr.php?section_id=' + sectionId)
            .then((resp) => resp.json())
            .then((data) => {
                const cities = data?.cities;
                if (!cities || !cities.length) {
                    throw new Error('no cities');
                }

                cities.map((city) => {
                    const option = document.createElement('option');
                    option.setAttribute('value', city);
                    option.innerText = city;
                    citiesSelect.append(option);
                })

                niceCities.update()
                programsSelect.removeAttribute('disabled');
                node.classList.remove('m-selects_loading');
            })
            .catch((err) => {
                console.log(err);
                node.remove();
            })



        citiesSelect.addEventListener('change', async () => {
            await fetch('/ajax/get_cities_arr.php?section_id=' + sectionId + '&city=' + citiesSelect.value)
                .then((resp) => resp.json())
                .then((data) => {
                    programsSelect.setAttribute('disabled', 'disabled');
                    programsSelect.value = '';
                    const currentOptions = [...programsSelect.querySelectorAll('option')];
                    currentOptions.map((el, index) => {
                        if (index !== 0) el.remove();
                    })
                    link.classList.add('disabled');
                    const programs = data?.programs;
                    if (!programs || !programs.length) {
                        throw new Error('no programs for this city');
                    }

                    programs.map((program) => {
                        const option = document.createElement('option');
                        option.setAttribute('value', program.program);
                        option.innerText = program.program;
                        programsSelect.append(option);
                    })
                    programsSelect.removeAttribute('disabled');
                    nicePrograms.update();

                })
                .catch((err) => {
                    console.log(err)
                })
        })

        programsSelect.addEventListener('change', () => {
            if (programsSelect.value) {

                targetLink.searchParams.append('city', citiesSelect.value);
                targetLink.searchParams.append('selected', programsSelect.value);
                targetLink.hash = 'course-main-list'

                link.setAttribute('href', targetLink.href);

                //link.setAttribute('href', sectionLink + '?city=' + citiesSelect.value + '&selected=' + programsSelect.value + '#course-main-list');
                link.classList.remove('disabled');
            }
        })
    }

    for (const catalogSelect of document.querySelectorAll('.js-m-selects')) {
        setCatalogSelects(catalogSelect);
    }
})
